import { IFieldInfo } from '../Queries/EkonomiskAnalysQuery/EkonomiskAnalysQuery';
import { getFieldInfoValue } from './fieldInfoUtils';

export const getCurrencyFormatterParams = (
  { fieldInfo }: { fieldInfo: IFieldInfo[] },
  base: number = 1,
  decimals: number = 2,
  displayZero: string = 'Y'
): string => {
  return (
    `Base="${base}";Decimals="${decimals}";DisplayZeroAsBlank="${displayZero}";ForceDecimals="Y"` +
    getParamVandTecken(fieldInfo, false)
  );
};

const getParamVandTecken = (
  fieldInfos: IFieldInfo[],
  first: boolean = true
) => {
  let params = '';

  if (getFieldInfoValue('VAND_TECKEN', fieldInfos)) {
    params += `${first ? '' : ';'}ReverseSign="Y"`;
  }

  return params;
};
